// extracted by mini-css-extract-plugin
export default {"subSection":"subsection__subSection-jokdw","header":"subsection__header-ooWsg","children":"subsection__children-qqOf3","tooltip":"subsection__tooltip-eLz8Z"};